export const determineMonthlySavingsAmt = (savingsInfo) => {
    let totalMonthlySavingsAmt = 0;
    for (let i=0; i<savingsInfo.savingsArr.length; i++){
        const savingsArr = savingsInfo.savingsArr[i];
        if (!savingsArr.closedDate && savingsArr.monthlyDepositAmt){
            totalMonthlySavingsAmt += +savingsArr.monthlyDepositAmt;
        }
    }
    return totalMonthlySavingsAmt;
}

export default determineMonthlySavingsAmt;